export enum DisplayUnitType {
    PIXELS = "pixelsNumber",
    PIXELS_STRING = "pixelsString",
    REMS = "remsNumber",
    REMS_STRING = "remsString"
}
